import { API } from "@/new_api";
export default {
  install: app => {
    app.config.globalProperties.$apple_pay = {
      instance: null,
      initApplePay: async () => {
        try {
          // TODO f = 10 несуществующая версия, пока braintree не работает
          if (app.config.globalProperties.$versions.f !== 10) {
            const payload = {
              validation_url: 'https://apple-pay-gateway.apple.com/paymentservices/startSession',
              domain_name: process.env.VUE_APP_URL.replace('https://', ''),
              display_name: 'Dr. Kegel',
              key: process.env.VUE_APP_STRIPE_KEY
            }
            var { data, status } = await API.STRIPE.apple_pay_init(payload);
          } else {
            const payload = {
              applePayWebSession: {
                validationUrl: "https://apple-pay-gateway-cert.apple.com/paymentservices/startSession",
                domainName: process.env.VUE_APP_URL.replace('https://', ''),
                merchantIdentifier: "merchant.appercut.braintree",
                displayName: "Dr. Kegel"
              },
              tokenizationKey: "sandbox_24xprpxk_95dqhww6s625y25h"
            }
            var { data, status } = await API.BRAINTREE.apple_pay_init(payload);
          }

          if (status === 200) {
            app.config.globalProperties.$apple_pay.instance = data;
            return true
          }
        } catch(error) {
          console.error(error);
          return false;
        }
      },
      onClick: ({ amount, item, uuid, upsale }, onTrack, disableButton, onError, onCancel, onSuccess, buyUpsale) => {
        if (!window.ApplePaySession) {
          return
        }

        const request = {
          countryCode: "US",
          currencyCode: "USD",
          merchantCapabilities: [
            "supports3DS"
          ],
          supportedNetworks: [
            "visa",
            "masterCard",
            "amex",
            "discover"
          ],
          total: {
            label: "Dr. Kegel",
            type: "final",
            amount
          },
          web_user_uuid: uuid
        };

        const session = new ApplePaySession(3, request);


        session.onvalidatemerchant = event => {
          if(app.config.globalProperties.$versions.f !== 10) {
            const sessionData = app.config.globalProperties.$apple_pay.instance.session;
            const merchantSession = JSON.parse(sessionData);
            session.completeMerchantValidation(merchantSession);
          } else {
            const sessionData = app.config.globalProperties.$apple_pay.instance;
            session.completeMerchantValidation(sessionData);
          }
        };

        session.onpaymentmethodselected = event => {
          const update = {
            newTotal: {
              label: "Dr. Kegel",
              type: "final",
              amount: amount
            }
          }
          session.completePaymentMethodSelection(update);
          onTrack('applepay_payment_method_selected')
          disableButton(false)
        };

        session.onshippingmethodselected = event => {
          const update = {
            newTotal: {
              label: "Dr. Kegel",
              type: "final",
              amount: amount
            }
          }
          session.completeShippingMethodSelection(update);
        };

        session.onshippingcontactselected = event => {
          const update = {};
          session.completeShippingContactSelection(update);
        };

        session.onpaymentauthorized = async event => {
          // Define ApplePayPaymentAuthorizationResult
          disableButton(false)
          onTrack('applepay_onpaymentauthorized_call')

          const result = {
            status: ApplePaySession.STATUS_SUCCESS
          };

          const { token } = event.payment;

          try {
            let data = {};
            if (app.config.globalProperties.$versions.f !== 10) {
            const tokens_payload = {
              pk_token: JSON.stringify(token.paymentData),
              pk_token_transaction_id: token.transactionIdentifier,
              pk_token_payment_network: token.paymentMethod.network,
              pk_token_instrument_name: token.paymentMethod.displayName,
              key: process.env.VUE_APP_STRIPE_KEY
            }
            const response = await API.STRIPE.tokens(tokens_payload);
            data = response?.data;
            var applepay_token = data.id

            } else {
              const tokens_payload = {
                applePaymentToken: {
                  paymentData: btoa(JSON.stringify(token.paymentData)),
                },
                tokenizationKey: process.env.VUE_APP_BRAINTREE_KEY
              }
              const response = await API.BRAINTREE.tokens(tokens_payload);
              data = response?.data;
              var applepay_token = data.applePayCards[0].nonce
            }


            if (upsale) {
              buyUpsale(data.id);
              session.completePayment(result);
            } else {
              try {
                const accept_payload = {
                  body: {
                    stripe_temp_token: applepay_token,
                    item,
                    raw_stripe_apple_pay: true,
                    web_user_uuid: uuid,
                  },
                  onSuccess,
                  onError
                }

                if (app.config.globalProperties.$versions.f === 10) {
                  accept_payload.body.gateway_id = process.env.VUE_APP_BRAINTREE_ID;
                } else {
                  accept_payload.body.gateway_id = process.env.VUE_APP_STRIPE_ID;
                }

                const error = await app.config.globalProperties.$store.dispatch('acceptWalletPayment', accept_payload);
                if (!error) {
                  onTrack('applepay_auth_success')
                  session.completePayment(result);
                }
              } catch (error) {
                onError({ stage: 'ApplePay', error })
                result.status = ApplePaySession.STATUS_FAILURE;
                onTrack('applepay_auth_error')
                session.completePayment(result);
              }
            }

          } catch (error) {
            onError({ stage: 'ApplePay', error })
            result.status = ApplePaySession.STATUS_FAILURE;
            session.completePayment(result);
          }
        };

        session.oncouponcodechanged = event => {
          // Define ApplePayCouponCodeUpdate
          const newTotal = calculateNewTotal(event.couponCode);
          const newLineItems = calculateNewLineItems(event.couponCode);
          const newShippingMethods = calculateNewShippingMethods(event.couponCode);
          const errors = calculateErrors(event.couponCode);

          session.completeCouponCodeChange({
            newTotal: newTotal,
            newLineItems: newLineItems,
            newShippingMethods: newShippingMethods,
            errors: errors,
          });
        };

        session.oncancel = event => {
          onCancel()
          onTrack('applepay_syscheeckout_closed');
        };

        session.begin();

        setTimeout(() => {
          disableButton(false)
        }, 1000)
      }
    }
  }
}
